// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"05ba30d3","769":"d3777a7b"}[chunkId] + ".chunk.js";
};